import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { Box, Typography } from "@mui/material";

// Sample data representing movies and their engagement rates
const data = [
  { name: "Dark Knight", likes: 80, dislikes: 20 },
  { name: "Mission Impossible", likes: 60, dislikes: 40 },
  { name: "Iron Man", likes: 70, dislikes: 43 },
  { name: "Minority Report", likes: 50, dislikes: 60 },
];

const EngagementRateChart = () => {
  const formatPercent = (value) => `${value}%`;
  return (
    <Box
      sx={{
        border: "1px solid lightgrey",
        padding: "20px",
        borderRadius: "10px",
      }}
      textAlign="center"
      width={"100%"}
    >
      <Typography variant="p" gutterBottom>
        Engagement Rate per Movie
      </Typography>

      {/* Wrap BarChart in ResponsiveContainer for responsiveness */}
      <ResponsiveContainer width="100%" height={300}>
        <BarChart
          data={data}
          margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="name"
            style={{ fontSize: "12px" }}
            interval={0} // Ensures all labels are shown
            angle={0} // Rotate labels to prevent overlap
            dy={10} // Adjust label position
          />
          <YAxis tickFormatter={formatPercent} />
          <Tooltip />
          <Bar dataKey="likes" stackId="a" fill="#4CAF50" />
          <Bar dataKey="dislikes" stackId="a" fill="#F44336" />
          <Legend />
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default EngagementRateChart;
